// In-memory access token store. Refresh token is stored in an httpOnly cookie
// by the backend so the browser cannot touch it directly.

let accessToken: string | null = null;
const listeners = new Set<(token: string | null) => void>();

export const authStorage = {
  get(): string | null {
    return accessToken;
  },
  set(token: string | null): void {
    accessToken = token;
    for (const cb of listeners) cb(token);
  },
  clear(): void {
    accessToken = null;
    for (const cb of listeners) cb(null);
  },
  subscribe(cb: (token: string | null) => void): () => void {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
};
